<template>
  <div class="scs-right-aligned-dynamic-event-details">
    <p v-for="(detail, index) in details" :key="index">
      {{ detail }}
    </p>
  </div>
</template>
<script>
import {
  formatTime,
  formatDate,
  balanceOutstanding,
  formatPrice,
  total,
} from "../../../../Helpers/invoice.js";

export default {
  data() {
    return {};
  },
  computed: {
    details() {
      return this.requests.map((x) => {
        switch (x) {
          case "formatted-date":
            return formatDate(
              this.event.data ? this.event.data.date : this.event.date
            );
          case "formatted-start-and-end":
            return `${formatTime(
              this.event.start_time
                ? this.event.start_time
                : this.event.data.startTime,
              this.event.time_zone ? this.event.time_zone.Name : null
            )} - ${formatTime(
              this.event.end_time
                ? this.event.end_time
                : this.event.data.endTime,
              this.event.time_zone ? this.event.time_zone.Name : null
            )}`;
          case "balance-outstanding":
            return `${formatPrice(balanceOutstanding(this.event))} outstanding`;
          case "total":
            return formatPrice(total(this.event));
          default:
            break;
        }
      });
    },
  },
  methods: {},
  created() {},
  components: {},
  props: ["event", "requests"],
};
</script>
<style scoped>
p {
  margin: 0px;
  font-weight: 500;
  font-size: 0.65em;
  text-align: right;
}
</style>
